<template>
  <div> 
    <div class="container-fluid">
      <nav-bar-component></nav-bar-component>
      <setup-menu-nav-component></setup-menu-nav-component>
    </div>
    <div class="container-fluid">
      <div class="row justify-content-center">
        
        <div class="col-md-10">
          
          <div class="container">
            <p class="h3">Broadcasts</p>
            <p class="muted">You can use broadcasts to send one-time announcements and messages that show up in your user's notification feeds</p>
            <b-card>
            <b-table hover :items="eventTypeList" :fields="tableFields" sort-by="name">
              <template v-slot:cell(actions)="row">
                <b-button :to="{path:'/broadcasts/' + row.item.id}" size="sm" variant="link">
                  <b-icon icon="pencil" variant="primary"></b-icon> View/Edit
                </b-button>
              </template>

              <template v-slot:cell(warnings)="row">
                
                  <b-icon icon="exclamation-square-fill" v-b-tooltip.hover.top="{ variant: 'warning' }" title="This Braodcast doesn't have a template." variant="warning" v-if="row.item.warning"></b-icon>
                
              </template>
              
            </b-table>            
            <button type="button" class="btn btn-primary"  @click="createNewEventType">
              + New Broadcast Notification
            </button>
            </b-card>
          </div> 
          
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
// @ is an alias to /src
import NavBarComponent from '@/components/NavBarComponent.vue'
import SetupMenuNavComponent from '@/components/SetupMenuNavComponent.vue'
// Your corresponding keys
var Parse = require('parse/node');
Parse.initialize(process.env.VUE_APP_PARSE_APP_ID, process.env.VUE_APP_PARSE_JS_KEY, process.env.VUE_APP_PARSE_MASTER_KEY);
Parse.serverURL = process.env.VUE_APP_PARSE_SERVER_URL;

export default {
  name: 'Broadcasts',
  components: {
    NavBarComponent,
    SetupMenuNavComponent
  },
  mounted: function () {
    this.fetchEventTypes();

  },
  data: function () {
    return {
      eventTypeList: [],
      tableFields : [          
          {
            key: 'warnings',
            label: ''
          },
          {
            key: 'name'
          },
          {
            key: 'apiEndpoint',
            label: 'API Endpoint'
          },
          {
            key: 'actions',
            label: 'View/Edit'
          },
        ],
      companyId: '',
      isModalVisible: false
    }
  },
  created() {

  },
  methods: {


    fetchEventTypes() {
      const query1 = new Parse.Query(Parse.User);
      query1.get(Parse.User.current().id).then((user) => {
        console.log('User found', user.attributes.CompanyId.id);
        this.companyId = user.attributes.CompanyId.id;
        
        console.log('fetch user - this.companyId = ', this.companyId);
        const EventType = Parse.Object.extend("EventType");
        const query = new Parse.Query(EventType);
        query.equalTo("CompanyId", { "__type": "Pointer", "className": "Company", "objectId": this.companyId });
        query.equalTo("Type", "Broadcast");
        query.include("NotificationTemplates");
        query.ascending("Name");
        query.find().then((tempEventTypeList) => {

          tempEventTypeList.forEach(cur => {
            cur.relation("NotificationTemplates").query().count().then((templateCount) => {
              this.eventTypeList.push(this.wrapEventType(cur, templateCount));
            });
          });
          //this.wrapEventTypes(tempEventTypeList);
        })
      }, (error) => {
        console.error('Error while fetching user', error);
      });
    },
    wrapEventType(itemToWrap, tempCount) {
      
      let curWrapper = {
        id : itemToWrap.id,
        name : itemToWrap.get('Name'),
        apiEndpoint : 'https://api.ravenhub.io/company/' + this.companyId + '/subscribers/<subscriber_id>/events/' +  itemToWrap.id,
        warning: tempCount > 0 ? false : true
      }
      return curWrapper;
      
    },
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    createNewEventType() {
      this.$router.replace("/broadcasts/new");
    }
   
  }
}
</script>
